export default {
  formId: "loginForm",
  formField: {
    phoneNumber: {
      name: "phoneNumber",
      label: "Phone Number*",
      requiredErrorMsg: "Phone is required",
    },
    otpCode: {
      name: "otpCode",
      label: "Pin Code*",
      requiredErrorMsg: "Pin Code is required",
    },
  },
};
